<template>
  <v-dialog
    v-model="showDialog"
    max-width="660"
    @click:outside="cancelDialog"
    content-class="publish-unpublish-dialog"
  >
    <v-card>
      <v-card-title>
        <h3>{{ action.charAt(0).toUpperCase() + action.slice(1) }} this template?</h3>
      </v-card-title>

      <v-card-text>
        <p>Are you sure you want to {{ action }} this template?</p>
      </v-card-text>

      <v-card-actions class="justify-center buttons">
        <v-btn text @click="cancelDialog">Cancel</v-btn>

        <v-btn :color="action.toLowerCase() === 'publish' ? '#6DB42C' : 'red'" style="color: white" @click="confirmDialog" :disabled="loading">
          <v-icon left v-if="!loading">fas fa-globe-europe</v-icon>
          <v-icon left v-else>fas fa-spinner fa-spin</v-icon>
          {{ action.toUpperCase() }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    loading: false,
  }),
  props: ["showPublishUnpublishDialog", "action", "templateId"],
  computed: {
    showDialog: {
      get() {
        return this.showPublishUnpublishDialog;
      },
      set(value) {
        this.$emit("update:showPublishUnpublishDialog", value);
      }
    }
  },
  watch: {
    showPublishUnpublishDialog() {
      this.loading = false;
    },
  },
  methods: {
    cancelDialog() {
      this.showDialog = false;
    },
    confirmDialog() {
      this.loading = true;
      const data = {
        action: this.action,
        templateId: this.templateId,
      };

      this.$emit("confirmPublishUnpublishDialog", data);
    },
  },
};
</script>

<style scoped>
.publish-unpublish-dialog h3,
p {
  font-family: "Montserrat";
  text-align: center;
}

.publish-unpublish-dialog h3 {
  margin: 0 auto;
  margin-top: 30px;
  margin-bottom: 30px;
}

.publish-unpublish-dialog p {
  font-weight: 500;
}

.publish-unpublish-dialog p:nth-child(2) {
  margin-top: -15px;
}

.publish-unpublish-dialog .buttons {
  padding-bottom: 60px;
}

.buttons {
  font: 12px/15px "Montserrat";
}
</style>